import React, {useEffect, useState} from "react";
import {useClientContext} from "./ClientContext";
import ValidateClientPasswordComponent from "./ValidateClientPasswordComponent";
import toast from "react-hot-toast";
import Modal from "../../components/atoms/Modal";
import InputGroup from "../../components/atoms/InputGroup";
import BtnModal from "../../components/atoms/BtnModal";
import {isNumeric} from "../../tools/tools";

export default function EditClientModal() {
    const {
        addUpdateClient,
        closeModal,
        modalState
    } = useClientContext();


    const initState = {
        name: '', number: '', city: '', datebirth: '',
    };

    const [formData, setFormData] = useState(initState);

    const isEdit = modalState.mode === 'edit';
    const isOpen = modalState.mode!=="delete" &&modalState.isOpen;

    useEffect(() => {
        if (isEdit) {
            setFormData(modalState.selectedItem);
        } else {
            setFormData(initState);
        }
    }, [modalState]);

    const title = isEdit ? `ویرایش کاربر "${modalState.selectedItem.name}"` : "افزودن کاربر";
    const btnTitle = isEdit ? "تایید اطلاعات و ویرایش" : "تایید اطلاعات و افزودن";

    const handleInputChange = (field, value) => {

        setFormData(prev => ({...prev, [field]: value}));
    };

    const handleSubmit = () => {
        console.log("HANDLE SUBMIT: ",formData)
        if (formData.name.trim().length === 0 || formData.number.trim().length === 0) {
            // Check if name or number is empty
            toast.error("مشخصات خود را کامل کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        } else if (!isNumeric(formData.number)) {
            // Check if number is not numeric
            toast.error("شماره خود را صحیح وارد کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        if (modalState.mode === "edit") {

            addUpdateClient({
                id: modalState.selectedItem.id, ...formData
            })
        } else {
            addUpdateClient(formData)
        }
        closeModal()
    };

    if (!isOpen) return null;
    return (<>
        <Modal title={title} closeModal={closeModal}>
            <div className="flex flex-col gap-4 mb-5">
                <div className="flex gap-4">
                    <InputGroup
                        placeholder="مانند علی میرهادی"
                        label="نام و نام خانوادگی"
                        val={formData.name}
                        iconName="userF"
                        onchange={(event) => handleInputChange('name', event.target.value)}
                        id="name"
                    />
                    <InputGroup
                        placeholder="مانند 09175843681"
                        label="شماره تماس"
                        val={formData.number}
                        iconName="call"
                        onchange={(event) => handleInputChange('number', event.target.value)}
                        id="number"
                    />
                </div>

                <div className="flex gap-4">
                    <InputGroup
                        placeholder="مانند فارس، شیراز"
                        label="استان و شهر (اختیاری)"
                        val={formData.city}
                        iconName="location"
                        onchange={(event) => handleInputChange('city', event.target.value)}
                        id="city"
                    />
                    <InputGroup
                        placeholder="مانند مدیر اجرایی"
                        label="شغل"
                        val={formData.datebirth}
                        iconName="calendar"
                        onchange={(event) => handleInputChange('datebirth', event.target.value)}
                        id="datebirth"
                    />
                </div>
            </div>

            {isEdit && (<ValidateClientPasswordComponent
                id={modalState.selectedItem.id}
            />)}

            <div className="flex justify-end pt-6">
                <BtnModal
                    text={btnTitle}
                    accept={handleSubmit}
                    disabled={!formData.name || !formData.number}
                />
            </div>
        </Modal>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"/>
    </>);
}